import { render, staticRenderFns } from "./Tab1.vue?vue&type=template&id=0a9ebeae&scoped=true"
import script from "./Tab1.vue?vue&type=script&lang=js"
export * from "./Tab1.vue?vue&type=script&lang=js"
import style0 from "./Tab1.vue?vue&type=style&index=0&id=0a9ebeae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9ebeae",
  null
  
)

export default component.exports